<template>
  <div>
    <div class="hero hero-cover hero-gradient">
      <div class="container">
        <h1 class="text-white text-center">Usluge</h1>
      </div>
    </div>

    <div class="section bg-white text-gray-700 push-content">
      <div class="container" v-scroll-reveal>
        <p class="text-center text-xl xl:text-2xl italic font-light">Razumijevanje tehnoloških i poslovnih potreba pojedinih poslovnih sustava preduvjet je za optimizaciju elektro-energetskih sustava i smanjenje kapitalnih investicija. Primjenom najboljih praksi implementiramo cjelokupne elektro-energetske sustave u sklopu građevinskih i ostalih projekata, a svojim znanjem i iskustvom u mogućnosti smo svojim korisnicima pružiti usluge izvođenja elektro-energetskih instalacija i strukturnog kabliranja, realizacije svjetlovodnih trasa te same distribucije proizvoda naših principala. </p>
        <p class="text-center text-xl xl:text-2xl italic font-light">Osluškujući potrebe klijenata, a u skladu s industrijskim standardima, rigoroznim testiranjima i kontrolom kvalitete razvili smo vlastiti proizvod i uslugu - SupraControl. SupraControl je jedinstven sustav za kontrolu pristupa i nadzor uvjeta rada u telekomunikacijskim i poslužiteljskim ormarima te podatkovnim centrima.</p>
      </div>
    </div>

    <div class="section bg-gray-100 text-secondary">
      <div class="container _xl pull-content">
        <div class="flex flex-wrap">
          <router-link
            v-for="(service, i) in services"
            :key="`service-${i}`"
            :to="service && service.route ?
                { name: service.route } :
                { name: 'service', params: { slug: service.slug } }
              "
            class="card h-72 lg:h-112 xl:h-128 xxl:h-152 fhd:h-176 cols p-10 bg-cover relative _overlay md:py-16 xl:pt-24 xl:pb-18"
            :class="[ (services.length % 2) !== 0 && i + 1 == services.length ? 'cols-full' : '' ]"
            :style="`background-image: url('${service.image}')`"
            v-scroll-reveal
          >
            <div class="card-body z-1 absolute bottom-12 lg:bottom-26">
              <h3 class="card-title">
                <span class="text-white xxl:text-4xl">{{ service.name }}</span>
              </h3>
              <p
                class="leading-tight text-gray-300 italic my-4 xl:my-8"
                v-if="service.description"
                v-html="service.description"></p>
              <span class="card-next">
                <img src="/svg/next.svg" alt />
              </span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      services: []
    };
  },

  mounted() {
    this.getServices();
  },

  methods: {
    getServices() {
      this.$http
        .get("/services")
        .then(response => {
          if (!_.isEmpty(response.data.data)) {
            this.services = response.data.data;

            this.services.push({
              id: null,
              name: 'SupraSolar',
              description: 'Projektiranje i implementacija fotonaponskih solarnih elektrana po najvišim standardima i modelu ključ u ruke',
              image: '/img/services/suprasolar.jpg',
              route: 'suprasolar'
            })
          }
        })
        .catch(error => {
          console.log(error);
          console.log(error.response);
        });
    }
  },

  metaInfo: {
    title: "Usluge",
    meta: [
      {
        vmid: "og:image",
        property: "og:image",
        content: "https://www.supranet.hr/img/services/usluge.jpg"
      }
    ]
  }
};
</script>
